export default __webpack_public_path__ + "static/observability-cloud-native-serverless-applications-a1a5b3bcc44bd73811f3cdc0c21bc696.jpg";